<template>
  <div>
    <!-- DISHA Section -->
    <h1 class="subheading text-center mt-8" style="color: #f28a3e">DISHA</h1>
    <div id="disha" class="team">
      <v-container>
        <v-row>
          <v-col
            v-for="(item, index) in dishaItems"
            :key="index"
            cols="12"
            sm="6"
            md="4"
            lg="2"
          >
            <a
              :href="item.href"
              style="text-decoration: none; display: block; width: 100%"
            >
              <div class="tile-container tileCtr">
                <div
                  class="icon-container iconCtr"
                  :style="{ backgroundColor: item.bgColor }"
                >
                  <v-icon
                    :style="{ color: item.iconColor, fontSize: '2.5rem' }"
                  >
                    {{ item.iconName }}
                  </v-icon>
                </div>
                <div
                  class="title-container titleCtr"
                  :style="{ color: item.iconColor }"
                >
                  {{ item.title }}
                </div>
              </div>
            </a>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- Phone Delivery Section -->
    <h1 class="subheading text-center mt-8" style="color: #f28a3e">
      Phone Delivery
    </h1>
    <div id="ivr" class="ivr">
      <v-container>
        <v-row>
          <v-col
            v-for="(item, index) in phoneDeliveryItems"
            :key="index"
            cols="12"
            sm="6"
            md="4"
            lg="2"
          >
            <a
              :href="item.href"
              style="text-decoration: none; display: block; width: 100%"
            >
              <div class="tile-container tileCtr">
                <div
                  class="icon-container iconCtr"
                  :style="{ backgroundColor: item.bgColor }"
                >
                  <v-icon
                    :style="{ color: item.iconColor, fontSize: '2.5rem' }"
                  >
                    {{ item.iconName }}
                  </v-icon>
                </div>
                <div
                  class="title-container titleCtr"
                  :style="{ color: item.iconColor }"
                >
                  {{ item.title }}
                </div>
              </div>
            </a>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- B2B Section -->
    <h1 class="subheading text-center mt-8" style="color: #f28a3e">B2B</h1>
    <div id="ivr" class="ivr">
      <v-container>
        <v-row>
          <v-col
            v-for="(item, index) in b2bItems"
            :key="index"
            cols="12"
            sm="6"
            md="4"
            lg="2"
          >
            <a
              :href="item.href"
              style="text-decoration: none; display: block; width: 100%"
            >
              <div class="tile-container tileCtr">
                <div
                  class="icon-container iconCtr"
                  :style="{ backgroundColor: item.bgColor }"
                >
                  <v-icon
                    :style="{ color: item.iconColor, fontSize: '2.5rem' }"
                  >
                    {{ item.iconName }}
                  </v-icon>
                </div>
                <div
                  class="title-container titleCtr"
                  :style="{ color: item.iconColor }"
                >
                  {{ item.title }}
                </div>
              </div>
            </a>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      authKey: localStorage.getItem("auth-key"),
      phoneDeliveryItems: [
        {
          href: "https://spencers-ivr.attabot.in/",
          title: "Call-list",
          iconName: "mdi-phone",
          bgColor: "#FFEFD5",
          iconColor: "#F44336",
        },

        {
          href: "https://spencers-ivr.attabot.in/staff",
          title: "Staff-List",
          iconName: "person",
          bgColor: "#F3E5F5",
          iconColor: "#8E24AA",
        },
        {
          href: "https://spencers-ivr.attabot.in/outboundCallerList",
          title: "Outbound Calls",
          iconName: "mdi-phone-classic",
          bgColor: "#F1F8E9",
          iconColor: "#8BC34A",
        },
        {
          href: "https://spencers-ivr.attabot.in/order-recordings",
          title: "Order-Recordings",
          iconName: "mdi-dialpad",
          bgColor: "#EFEBE9",
          iconColor: "#6D4C41",
        },
        {
          href: "https://spencers-ivr.attabot.in/order",
          title: "Order-List",
          iconName: "mdi-cart-outline",
          bgColor: "#FFEBEE",
          iconColor: "#D32F2F",
        },

        {
          href: "https://spencers-ivr.attabot.in/dialedCallList",
          title: "Dial List",
          iconName: "mdi-phone-log",
          bgColor: "#E0F7FA",
          iconColor: "#00796B",
        },
        {
          href: "https://spencers-ivr.attabot.in/setting",
          title: "General-Settings",
          iconName: "mdi-wrench",
          bgColor: "#EFEBE9",
          iconColor: "#6D4C41",
        },
        {
          href: "https://spencers-ivr.attabot.in/contactUs",
          title: "Log Complain",
          iconName: "computer",
          bgColor: "#ECEFF1",
          iconColor: "#546E7A",
        },
      ],
      b2bItems: [
        {
          href: "https://spencers-ivr.attabot.in/categoryList",
          title: "B2B",
          iconName: "mdi-domain",
          bgColor: "#E8EAF6",
          iconColor: "#303F9F",
        },
        {
          href: "https://spencers-ivr.attabot.in/b2b-order",
          title: "B2B Order-List",
          iconName: "add_shopping_cart",
          bgColor: "#FBE9E7",
          iconColor: "#E64A19",
        },
      ],
      dishaItems: [
        {
          href: "https://spencers-visit.attabot.in/",
          title: "Dashboard",
          iconName: "dashboard",
          bgColor: "#FFEFD5",
          iconColor: "#F44336",
        },

        {
          href: "https://spencers-visit.attabot.in/checklist",
          title: "Checklist",
          iconName: "check",
          bgColor: "#E8EAF6",
          iconColor: "#303F9F",
        },
        {
          href: "https://spencers-visit.attabot.in/form",
          title: "Dynamic Form",
          iconName: "mdi-lumx",
          bgColor: "#FCE4EC",
          iconColor: "#D81B60",
        },
        {
          href: "https://spencers-visit.attabot.in/photo-sharing-event",
          title: "Events",
          iconName: "folder_shared",
          bgColor: "#EFEBE9",
          iconColor: "#6D4C41",
        },
        {
          href: "https://spencers-visit.attabot.in/report",
          title: "Report",
          iconName: "report",
          bgColor: "#E0F7FA",
          iconColor: "#00796B",
        },
        {
          href: "https://spencers-ivr.attabot.in/mis",
          title: "MIS",
          iconName: "mdi-chart-bar",
          bgColor: "#EFEBE9",
          iconColor: "#6D4C41",
        },

        {
          href: "https://spencers-visit.attabot.in/pop",
          title: "POP",
          iconName: "print",
          bgColor: "#ECEFF1",
          iconColor: "#607D8B",
        },
        {
          href: "https://spencers-visit.attabot.in/barcodeScan",
          title: "OSA",
          iconName: "mdi-jira",
          bgColor: "#F3E5F5",
          iconColor: "#8E24AA",
        },

        {
          href: "https://spencers-visit.attabot.in/petty-cash",
          title: "Petty Cash",
          iconName: "mdi-cash-multiple",
          bgColor: "#F1F8E9",
          iconColor: "#43A047",
        },

        {
          href: "https://spencers-visit.attabot.in/transaction-complain",
          title: "Transaction Complain",
          iconName: "mdi-cash-100",
          bgColor: "#E3F2FD",
          iconColor: "#1E88E5",
        },
        {
          href: "https://spencers-visit.attabot.in/stores",
          title: "Stores",
          iconName: "home",
          bgColor: "#FFF8E1",
          iconColor: "#604C00",
        },

        {
          href: "https://spencers-visit.attabot.in/user",
          title: "Users",
          iconName: "people",
          bgColor: "#E8F5E9",
          iconColor: "#000447",
        },

        {
          href: "https://spencers-visit.attabot.in/role",
          title: "Role",
          iconName: "person",
          bgColor: "#E8F5E9",
          iconColor: "#616161",
        },
        {
          href: "https://spencers-visit.attabot.in/document-share",
          title: "Store Document",
          iconName: "folder",
          bgColor: "#E0F7FA",
          iconColor: "#00796B",
        },
        {
          href: "https://spencers-visit.attabot.in/notes",
          title: "Notes",
          iconName: "list",
          bgColor: "#F5F5F5",
          iconColor: "#7986CB",
        },

        {
          href: "https://spencers-visit.attabot.in/schedule",
          title: "Schedule",
          iconName: "cloud",
          bgColor: "#E0F7FA",
          iconColor: "#4DD0E1",
        },

        {
          href: "https://spencers-visit.attabot.in/comments",
          title: "Comments",
          iconName: "mdi-message-text-outline",
          bgColor: "#FFF3E0",
          iconColor: "#FF7043",
        },

        {
          href: "https://spencers-visit.attabot.in/tags",
          title: "Tags",
          iconName: "mdi-tag",
          bgColor: "#FCE4EC",
          iconColor: "#D81B60",
        },

        // {
        //   href: "https://spencers-visit.attabot.in/vendorFeedbackReport",
        //   title: "NPS Vendor",
        //   iconName: "mdi-asterisk",
        //   bgColor: "#E3F2FD",
        //   iconColor: "#1976D2",
        // },
        // {
        //   href: "https://spencers-visit.attabot.in/nps",
        //   title: "Voice Of Customer",
        //   iconName: "person",
        //   bgColor: "#FCE4EC",
        //   iconColor: "#D81B60",
        // },

        {
          href: "https://spencers-visit.attabot.in/contactUs",
          title: "Log Complain",
          iconName: "computer",
          bgColor: "#ECEFF1",
          iconColor: "#546E7A",
        },
      ],
    };
  },
};
</script>

<style>
html {
  height: 100%;
  scroll-behavior: smooth;
}

.tileCtr {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 8px;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  background-color: #fff;
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  width: 100%;
  height: 150px;
}

.tileCtr:hover {
  cursor: pointer;
  transform: translateY(-5px);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 8px 15px;
}

.iconCtr {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-bottom: 10px;
  transition: transform 0.2s ease;
}

.iconCtr:hover {
  transform: rotate(10deg);
}

.titleCtr {
  margin-top: 10px;
  font-size: 0.9rem;
  font-weight: bold;
  color: #333;
  width: 100%;
  text-align: center;
  white-space: normal;
  line-height: 1.2;
}
</style>
